/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as HomeRouteImport } from './routes/home'
import { Route as LoginLinkModalRouteImport } from './routes/login-link-modal'
import { Route as AdminTenantsRouteImport } from './routes/admin/tenants'
import { Route as InnovationDaysDemoLayoutRouteImport } from './routes/innovation-days-demo/_layout'
import { Route as JobsJobIdRouteImport } from './routes/jobs/$jobId'
import { Route as AdminTenantsIndexRouteImport } from './routes/admin/tenants/index'
import { Route as AdminTenantsTenantIdRouteImport } from './routes/admin/tenants/$tenantId'
import { Route as InnovationDaysDemoLayoutIndexRouteImport } from './routes/innovation-days-demo/_layout/index'
import { Route as InnovationDaysDemoLayoutSummaryRouteImport } from './routes/innovation-days-demo/_layout/summary'
import { Route as InnovationDaysDemoLayoutViewerRouteImport } from './routes/innovation-days-demo/_layout/viewer'
import { Route as JobsJobIdOverviewRouteImport } from './routes/jobs/$jobId/overview'
import { Route as JobsJobIdSummaryRouteImport } from './routes/jobs/$jobId/summary'

const IndexLazyRouteImport = createFileRoute('/')()
const LoginLazyRouteImport = createFileRoute('/login')()
const LoginLinkLazyRouteImport = createFileRoute('/login-link')()
const FaqDataUsageLazyRouteImport = createFileRoute('/faq/data-usage')()
const FaqWhyEssenceLazyRouteImport = createFileRoute('/faq/why-essence')()

const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const LoginLinkLazyRoute = LoginLinkLazyRouteImport.update({
  id: '/login-link',
  path: '/login-link',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login-link.lazy').then((d) => d.Route))
const LoginLinkModalRoute = LoginLinkModalRouteImport.update({
  id: '/login-link-modal',
  path: '/login-link-modal',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsRoute = AdminTenantsRouteImport.update({
  id: '/admin/tenants',
  path: '/admin/tenants',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqDataUsageLazyRoute = FaqDataUsageLazyRouteImport.update({
  id: '/faq/data-usage',
  path: '/faq/data-usage',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/faq/data-usage.lazy').then((d) => d.Route),
)
const FaqWhyEssenceLazyRoute = FaqWhyEssenceLazyRouteImport.update({
  id: '/faq/why-essence',
  path: '/faq/why-essence',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/faq/why-essence.lazy').then((d) => d.Route),
)
const InnovationDaysDemoLayoutRoute =
  InnovationDaysDemoLayoutRouteImport.update({
    id: '/innovation-days-demo/_layout',
    path: '/innovation-days-demo',
    getParentRoute: () => rootRouteImport,
  } as any)
const JobsJobIdRoute = JobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsIndexRoute = AdminTenantsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminTenantsRoute,
} as any)
const AdminTenantsTenantIdRoute = AdminTenantsTenantIdRouteImport.update({
  id: '/$tenantId',
  path: '/$tenantId',
  getParentRoute: () => AdminTenantsRoute,
} as any)
const InnovationDaysDemoLayoutIndexRoute =
  InnovationDaysDemoLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InnovationDaysDemoLayoutRoute,
  } as any)
const InnovationDaysDemoLayoutSummaryRoute =
  InnovationDaysDemoLayoutSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => InnovationDaysDemoLayoutRoute,
  } as any)
const InnovationDaysDemoLayoutViewerRoute =
  InnovationDaysDemoLayoutViewerRouteImport.update({
    id: '/viewer',
    path: '/viewer',
    getParentRoute: () => InnovationDaysDemoLayoutRoute,
  } as any)
const JobsJobIdOverviewRoute = JobsJobIdOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => JobsJobIdRoute,
} as any)
const JobsJobIdSummaryRoute = JobsJobIdSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => JobsJobIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/home': typeof HomeRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/admin/tenants': typeof AdminTenantsRouteWithChildren
  '/innovation-days-demo': typeof InnovationDaysDemoLayoutRouteWithChildren
  '/jobs/$jobId': typeof JobsJobIdRouteWithChildren
  '/faq/data-usage': typeof FaqDataUsageLazyRoute
  '/faq/why-essence': typeof FaqWhyEssenceLazyRoute
  '/admin/tenants/$tenantId': typeof AdminTenantsTenantIdRoute
  '/innovation-days-demo/summary': typeof InnovationDaysDemoLayoutSummaryRoute
  '/innovation-days-demo/viewer': typeof InnovationDaysDemoLayoutViewerRoute
  '/jobs/$jobId/overview': typeof JobsJobIdOverviewRoute
  '/jobs/$jobId/summary': typeof JobsJobIdSummaryRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/innovation-days-demo/': typeof InnovationDaysDemoLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/home': typeof HomeRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/jobs/$jobId': typeof JobsJobIdRouteWithChildren
  '/faq/data-usage': typeof FaqDataUsageLazyRoute
  '/faq/why-essence': typeof FaqWhyEssenceLazyRoute
  '/admin/tenants/$tenantId': typeof AdminTenantsTenantIdRoute
  '/innovation-days-demo/summary': typeof InnovationDaysDemoLayoutSummaryRoute
  '/innovation-days-demo/viewer': typeof InnovationDaysDemoLayoutViewerRoute
  '/jobs/$jobId/overview': typeof JobsJobIdOverviewRoute
  '/jobs/$jobId/summary': typeof JobsJobIdSummaryRoute
  '/admin/tenants': typeof AdminTenantsIndexRoute
  '/innovation-days-demo': typeof InnovationDaysDemoLayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/home': typeof HomeRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/admin/tenants': typeof AdminTenantsRouteWithChildren
  '/innovation-days-demo/_layout': typeof InnovationDaysDemoLayoutRouteWithChildren
  '/jobs/$jobId': typeof JobsJobIdRouteWithChildren
  '/faq/data-usage': typeof FaqDataUsageLazyRoute
  '/faq/why-essence': typeof FaqWhyEssenceLazyRoute
  '/admin/tenants/$tenantId': typeof AdminTenantsTenantIdRoute
  '/innovation-days-demo/_layout/summary': typeof InnovationDaysDemoLayoutSummaryRoute
  '/innovation-days-demo/_layout/viewer': typeof InnovationDaysDemoLayoutViewerRoute
  '/jobs/$jobId/overview': typeof JobsJobIdOverviewRoute
  '/jobs/$jobId/summary': typeof JobsJobIdSummaryRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/innovation-days-demo/_layout/': typeof InnovationDaysDemoLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/home'
    | '/login-link-modal'
    | '/login'
    | '/login-link'
    | '/admin/tenants'
    | '/innovation-days-demo'
    | '/jobs/$jobId'
    | '/faq/data-usage'
    | '/faq/why-essence'
    | '/admin/tenants/$tenantId'
    | '/innovation-days-demo/summary'
    | '/innovation-days-demo/viewer'
    | '/jobs/$jobId/overview'
    | '/jobs/$jobId/summary'
    | '/admin/tenants/'
    | '/innovation-days-demo/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/home'
    | '/login-link-modal'
    | '/login'
    | '/login-link'
    | '/jobs/$jobId'
    | '/faq/data-usage'
    | '/faq/why-essence'
    | '/admin/tenants/$tenantId'
    | '/innovation-days-demo/summary'
    | '/innovation-days-demo/viewer'
    | '/jobs/$jobId/overview'
    | '/jobs/$jobId/summary'
    | '/admin/tenants'
    | '/innovation-days-demo'
  id:
    | '__root__'
    | '/'
    | '/home'
    | '/login-link-modal'
    | '/login'
    | '/login-link'
    | '/admin/tenants'
    | '/innovation-days-demo/_layout'
    | '/jobs/$jobId'
    | '/faq/data-usage'
    | '/faq/why-essence'
    | '/admin/tenants/$tenantId'
    | '/innovation-days-demo/_layout/summary'
    | '/innovation-days-demo/_layout/viewer'
    | '/jobs/$jobId/overview'
    | '/jobs/$jobId/summary'
    | '/admin/tenants/'
    | '/innovation-days-demo/_layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  HomeRoute: typeof HomeRoute
  LoginLinkModalRoute: typeof LoginLinkModalRoute
  LoginLazyRoute: typeof LoginLazyRoute
  LoginLinkLazyRoute: typeof LoginLinkLazyRoute
  AdminTenantsRoute: typeof AdminTenantsRouteWithChildren
  InnovationDaysDemoLayoutRoute: typeof InnovationDaysDemoLayoutRouteWithChildren
  JobsJobIdRoute: typeof JobsJobIdRouteWithChildren
  FaqDataUsageLazyRoute: typeof FaqDataUsageLazyRoute
  FaqWhyEssenceLazyRoute: typeof FaqWhyEssenceLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link': {
      id: '/login-link'
      path: '/login-link'
      fullPath: '/login-link'
      preLoaderRoute: typeof LoginLinkLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link-modal': {
      id: '/login-link-modal'
      path: '/login-link-modal'
      fullPath: '/login-link-modal'
      preLoaderRoute: typeof LoginLinkModalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants': {
      id: '/admin/tenants'
      path: '/admin/tenants'
      fullPath: '/admin/tenants'
      preLoaderRoute: typeof AdminTenantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/data-usage': {
      id: '/faq/data-usage'
      path: '/faq/data-usage'
      fullPath: '/faq/data-usage'
      preLoaderRoute: typeof FaqDataUsageLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/why-essence': {
      id: '/faq/why-essence'
      path: '/faq/why-essence'
      fullPath: '/faq/why-essence'
      preLoaderRoute: typeof FaqWhyEssenceLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/innovation-days-demo/_layout': {
      id: '/innovation-days-demo/_layout'
      path: '/innovation-days-demo'
      fullPath: '/innovation-days-demo'
      preLoaderRoute: typeof InnovationDaysDemoLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$jobId': {
      id: '/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof JobsJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants/': {
      id: '/admin/tenants/'
      path: '/'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AdminTenantsIndexRouteImport
      parentRoute: typeof AdminTenantsRoute
    }
    '/admin/tenants/$tenantId': {
      id: '/admin/tenants/$tenantId'
      path: '/$tenantId'
      fullPath: '/admin/tenants/$tenantId'
      preLoaderRoute: typeof AdminTenantsTenantIdRouteImport
      parentRoute: typeof AdminTenantsRoute
    }
    '/innovation-days-demo/_layout/': {
      id: '/innovation-days-demo/_layout/'
      path: '/'
      fullPath: '/innovation-days-demo/'
      preLoaderRoute: typeof InnovationDaysDemoLayoutIndexRouteImport
      parentRoute: typeof InnovationDaysDemoLayoutRoute
    }
    '/innovation-days-demo/_layout/summary': {
      id: '/innovation-days-demo/_layout/summary'
      path: '/summary'
      fullPath: '/innovation-days-demo/summary'
      preLoaderRoute: typeof InnovationDaysDemoLayoutSummaryRouteImport
      parentRoute: typeof InnovationDaysDemoLayoutRoute
    }
    '/innovation-days-demo/_layout/viewer': {
      id: '/innovation-days-demo/_layout/viewer'
      path: '/viewer'
      fullPath: '/innovation-days-demo/viewer'
      preLoaderRoute: typeof InnovationDaysDemoLayoutViewerRouteImport
      parentRoute: typeof InnovationDaysDemoLayoutRoute
    }
    '/jobs/$jobId/overview': {
      id: '/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/jobs/$jobId/overview'
      preLoaderRoute: typeof JobsJobIdOverviewRouteImport
      parentRoute: typeof JobsJobIdRoute
    }
    '/jobs/$jobId/summary': {
      id: '/jobs/$jobId/summary'
      path: '/summary'
      fullPath: '/jobs/$jobId/summary'
      preLoaderRoute: typeof JobsJobIdSummaryRouteImport
      parentRoute: typeof JobsJobIdRoute
    }
  }
}

interface AdminTenantsRouteChildren {
  AdminTenantsTenantIdRoute: typeof AdminTenantsTenantIdRoute
  AdminTenantsIndexRoute: typeof AdminTenantsIndexRoute
}

const AdminTenantsRouteChildren: AdminTenantsRouteChildren = {
  AdminTenantsTenantIdRoute: AdminTenantsTenantIdRoute,
  AdminTenantsIndexRoute: AdminTenantsIndexRoute,
}

const AdminTenantsRouteWithChildren = AdminTenantsRoute._addFileChildren(
  AdminTenantsRouteChildren,
)

interface InnovationDaysDemoLayoutRouteChildren {
  InnovationDaysDemoLayoutSummaryRoute: typeof InnovationDaysDemoLayoutSummaryRoute
  InnovationDaysDemoLayoutViewerRoute: typeof InnovationDaysDemoLayoutViewerRoute
  InnovationDaysDemoLayoutIndexRoute: typeof InnovationDaysDemoLayoutIndexRoute
}

const InnovationDaysDemoLayoutRouteChildren: InnovationDaysDemoLayoutRouteChildren =
  {
    InnovationDaysDemoLayoutSummaryRoute: InnovationDaysDemoLayoutSummaryRoute,
    InnovationDaysDemoLayoutViewerRoute: InnovationDaysDemoLayoutViewerRoute,
    InnovationDaysDemoLayoutIndexRoute: InnovationDaysDemoLayoutIndexRoute,
  }

const InnovationDaysDemoLayoutRouteWithChildren =
  InnovationDaysDemoLayoutRoute._addFileChildren(
    InnovationDaysDemoLayoutRouteChildren,
  )

interface JobsJobIdRouteChildren {
  JobsJobIdOverviewRoute: typeof JobsJobIdOverviewRoute
  JobsJobIdSummaryRoute: typeof JobsJobIdSummaryRoute
}

const JobsJobIdRouteChildren: JobsJobIdRouteChildren = {
  JobsJobIdOverviewRoute: JobsJobIdOverviewRoute,
  JobsJobIdSummaryRoute: JobsJobIdSummaryRoute,
}

const JobsJobIdRouteWithChildren = JobsJobIdRoute._addFileChildren(
  JobsJobIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  HomeRoute: HomeRoute,
  LoginLinkModalRoute: LoginLinkModalRoute,
  LoginLazyRoute: LoginLazyRoute,
  LoginLinkLazyRoute: LoginLinkLazyRoute,
  AdminTenantsRoute: AdminTenantsRouteWithChildren,
  InnovationDaysDemoLayoutRoute: InnovationDaysDemoLayoutRouteWithChildren,
  JobsJobIdRoute: JobsJobIdRouteWithChildren,
  FaqDataUsageLazyRoute: FaqDataUsageLazyRoute,
  FaqWhyEssenceLazyRoute: FaqWhyEssenceLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
